import React from 'react';
import { useTranslation } from 'react-i18next';
import backIcon from '../../pages/TransactionsFacelift/svg/back-arrow.svg';
import { CategoryList } from '../../pages/TransactionsFacelift/components/drawer-content/choose-category/CategoryList';
import Button from '../../generic-components/Button';
import { LiliTransaction } from '../../pages/TransactionsFacelift/types/lili-transaction';
import { ITransaction } from '../../types';
import { useStore } from '../../store';

interface ILiliDrawerProps {
  transaction: ITransaction;
}

export const LiliDrawer = ({ transaction }: ILiliDrawerProps) => {
  const { t } = useTranslation();
  const resetCategoriesDrawerSlice = useStore((state) => state.resetCategoriesDrawerSlice);
  const setSelectedCategoryDetails = useStore((state) => state.setSelectedCategoryDetails);
  const setActiveDrawerTransaction = useStore((state) => state.setActiveDrawerTransaction);
  const handleCategorySelection = async (categoryId: string, businessPercent: number) => {
    setSelectedCategoryDetails({ categoryId, businessPercent });
    setActiveDrawerTransaction(null);
  };
  const handleOnCloseClick = () => {
    resetCategoriesDrawerSlice();
  };

  return (
    <div>
      <div
        className='h-full w-full absolute top-0 left-0 z-50'
        aria-label='close'
        onClick={handleOnCloseClick}
        data-testid='LiliDrawer__overlay'
        role='button'
        onKeyDown={() => {}}
        tabIndex={0}
      />
      <div className='flex flex-col h-full w-[450px] bg-bw00 z-60 absolute right-0 top-0 translate-x-[100%] slide-in-right shadow-rightDrawerShadow z-[999]'>
        <div className='flex flex-col grow fadeIn relative'>
          <Button
            testId='LiliDrawer__close-btn'
            onClick={handleOnCloseClick}
            className='absolute top-[14px] right-[24px] rotate-180'
            id='backFromCategoryPicker'
            childElement={<img src={backIcon} alt='back' className='w-[20px]' />}
          />
          <div className='flex flex-col grow px-[30px]'>
            <div className='flex flex-col justify-between my-[14px] items-center'>
              <p className='text-center mb-2 font-metricRMedium text-bw08 text-[14px]'>
                {t('TRANSACTIONS.CHOOSE_CATEGORY')}
              </p>
              <div className='border-b-4 border-action03' />
            </div>
            <CategoryList transaction={transaction as LiliTransaction} onCategorySelect={handleCategorySelection} />
          </div>
        </div>
      </div>
    </div>
  );
};
